import Loader from "react-spinners/HashLoader";

export function loadingAnnimation(loading){
    return (
        <div className="Loader">
            <Loader color={"#000000"} loading={loading} css="" size={75} />
        </div>
    )
}